import styled from 'styled-components';
import { Button, Grid, Modal, Typography } from '@material-ui/core';

export const ModalContent = styled.div`
  background: white;
  transform: translate(-50%, -50%);
  padding: 10px 20px;
  border-radius: 2px;
`;

export const ModalPosition = styled(Modal)`
  top: 50% !important;
  left: 50% !important;
  width: ${({ width }) => width ?? '75%'};
  @media only screen and (max-width: 600px) {
    width: 90%;
  }
`;

export const ModalTitle = styled(Typography)`
  font-weight: bold;
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const GridTitle = styled(Grid)`
  display: flex;
  align-items: center;
`;

export const GridClose = styled(Grid)`
  display: flex;
  align-items: ${({ customtitle }) => (customtitle ? 'baseline' : 'center')};
  justify-content: flex-end;
`;

export const SuccessButton = styled(Button)`
  && {
    background: ${({ theme }) => theme.palette.primary.main};
    color: white;
    width: 100%;
    margin-top: 10px;
    &:hover {
      background: ${({ theme }) => theme.palette.primary.main};
      opacity: 0.8;
    }
  }
`;

export const BackButton = styled(Button)`
  && {
    color: white;
    width: 100%;
    background: ${({ theme }) => theme.palette.secondary.main};
    margin-top: 10px;
    &:hover {
      background: ${({ theme }) => theme.palette.secondary.main};
      opacity: 0.8;
    }
  }
`;

export const StyledItem = styled(Grid)`
  margin: 10px 0 0;
`;

export const OverflowModal = styled.div`
  overflow-y: auto;
  max-height: 60vh;
`;
